var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoomerangTapedBoom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b59767;}.cls-2{fill:#e2b985;}.cls-3{fill:#156392;}.cls-4{fill:#1c79be;}.cls-5{fill:#5c4a37;}.cls-6{fill:#b3b3b3;}.cls-7{fill:#cfcfce;}.cls-8{fill:#e5e5e5;}.cls-9{fill:#fff;}.cls-10{fill:#cccccb;}.cls-11{fill:#eaeaea;}.cls-12{fill:#e0e0e0;}.cls-13{fill:#f4f4f5;}.cls-14{fill:#e2e2e2;}.cls-15{fill:#f0efef;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "boomerang") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tapedBoom"
  }, /*#__PURE__*/React.createElement("g", {
    id: "boomerang-2",
    "data-name": "boomerang"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.32,243.67C285.82,220,103.41,222.82,89.15,165,79,123.94,93.5,64.49,78.39,44,66.6,28.11,21.52,109.74,45.23,183.26,70.66,262.1,289.2,273.3,287.32,243.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.32,243.67c-1.13-13.14-59.12-18.92-112.48-31.5-42-9.91-81.19-24-87.41-49.33C77.39,122.06,89,58.12,77,42.72c-10.2-13-58,65.71-33.45,138.34C54.83,214.6,108.09,234.93,162,245,224.71,256.84,288.28,254.79,287.32,243.67Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "boomerang-3",
    "data-name": "boomerang"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183,248.5l-.13,6.57a358,358,0,0,1-56.71-12.43l-.19-6v-.06c11.65,3.38,23.81,6.19,36,8.48C169,246.37,176,247.52,183,248.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M191.7,215.92s-.21.28-.57.84a42.79,42.79,0,0,0-4.66,10.76c-2.28,7.72-3.49,21-3.49,21-7-1-14-2.13-21-3.45-12.19-2.29-24.35-5.1-36-8.48-.06-.72-.52-7.88,2.35-17.91,2.64-9.21,5.64-14.5,7-16.59.47-.72.74-1.06.74-1.06a356.76,356.76,0,0,0,38.81,11.16C180.43,213.49,186.08,214.73,191.7,215.92Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M196.69,217s-.18.28-.48.82a58.6,58.6,0,0,0-4.58,10.64c-2.34,7.18-3.31,20.81-3.31,20.81v6.58l-3.09-.41-2.38-.31h0l.13-6.57s1.21-13.26,3.49-21a42.79,42.79,0,0,1,4.66-10.76c.36-.56.57-.84.57-.84l.9.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M136,201s-.27.34-.74,1.06c-1.35,2.09-4.35,7.38-7,16.59-2.87,10-2.41,17.19-2.35,17.91v.06l.19,6-.24-.08-4.6-1.5-.31-6v0a57.07,57.07,0,0,1,2.48-17.37,77.82,77.82,0,0,1,7.32-17.32c.4-.68.63-1,.63-1l2.32.85Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "boomerang-4",
    "data-name": "boomerang"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.46,176.24q-.9-1.08-1.71-2.19a168.34,168.34,0,0,0-19.54,10.81C64.67,190.66,58,202,57.75,202.41h0v1.94a64.15,64.15,0,0,1-8.66-12.14,52.42,52.42,0,0,1-3.86-9c-.46-1.43-.9-2.86-1.3-4.3,3.62-3.25,12-10.32,19.53-13,10.78-3.79,23.66-4.45,23.66-4.45l1.31.29q.33,1.6.72,3.18A31.53,31.53,0,0,0,92.93,174Q93.65,175.13,94.46,176.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.75,174a168.34,168.34,0,0,0-19.54,10.81C64.67,190.66,58,202,57.75,202.41a62.86,62.86,0,0,1-8.66-10.19A46.91,46.91,0,0,1,43.5,181c-.15-.44-.29-.87-.43-1.31l.86-.78c3.62-3.25,12-10.32,19.53-13,10.78-3.79,23.66-4.45,23.66-4.45.1.43.2.86.31,1.29A32.1,32.1,0,0,0,92.75,174Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tape"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M51,194.65l-.17.54c-1.71-2.72-3.48-4.69-4.84-7.44l.15-.48C47.59,189.74,49.22,192.19,51,194.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95.3,177.53l-.36,0a133.42,133.42,0,0,0-20.39,3.9C62.61,184.63,51,194.65,51,194.65c-1.77-2.45-3.4-4.91-4.86-7.37h0c.44-.37,11.85-10.05,23.55-13.17a138.91,138.91,0,0,1,21.52-3.65,15.42,15.42,0,0,0,1.33,2.85C93.52,174.86,94.4,176,95.3,177.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tape-2",
    "data-name": "tape"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M56.81,201.45l.56,2.59c-2.31-2.11-4.51-5.55-6.16-8.15l-.32-1.21C52.91,196.63,54.52,199.61,56.81,201.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M91.54,171.17c-.1,0-.48.28-.59.34a111,111,0,0,0-16.2,9.42c-9.87,6.69-17.94,20.52-17.94,20.52-2.29-1.84-3.89-4.83-5.91-6.76,0,0,.32-.65.32-.66.29-.49,7.38-12.17,17.06-18.75,7.39-5,15.79-6.93,20.43-9.14.61.84,1.38,2.37,1.9,3.29A9.94,9.94,0,0,1,91.54,171.17Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tape-3",
    "data-name": "tape"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M88.43,161.84l-1.31-.29q-.84-3.64-1.48-7.5l1.54.9Q87.71,158.46,88.43,161.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M87.12,161.55s-12.88.66-23.66,4.45c-7.5,2.64-15.91,9.71-19.53,13l-.86.78q-1.52-4.63-2.64-9.3l1.16-.9c4.53-3.43,13.11-9.51,20-11.94,10.77-3.79,24-3.55,24-3.55Q86.29,157.9,87.12,161.55Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tape-4",
    "data-name": "tape"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M90.79,169.87l-.62.1c-.6-2.59-2.43-5.26-2.89-8l1.28.51C88.94,165,90.28,167.46,90.79,169.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M90.17,170s-14.65.81-25.8,4.95c-7.76,2.88-13.89,8.5-17.61,12l-.89.84a42.22,42.22,0,0,1-3.61-8.92l1.2-1c4.67-3.7,11.78-9.26,18.92-11.91,11.14-4.14,24.9-4,24.9-4C87.74,164.71,89.57,167.37,90.17,170Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tape-5",
    "data-name": "tape"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M63.46,207.41v2.7a79.3,79.3,0,0,1-5.71-5.75v-1.94C59.53,204.13,61.44,205.79,63.46,207.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M97.52,179.54l-.28.13a144.29,144.29,0,0,0-18.32,10.18c-8.71,5.9-15.46,17.56-15.46,17.56-2-1.62-3.93-3.28-5.71-5h0c.26-.43,6.92-11.75,15.46-17.55A171.21,171.21,0,0,1,92.93,174c.54.74.93,1.56,1.53,2.28A42.72,42.72,0,0,0,97.52,179.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tape-6",
    "data-name": "tape"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M53.93,199.07l-.14.55c-1.87-2.61-3.75-4.47-5.27-7.13l.12-.49C50.24,194.37,52,196.73,53.93,199.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M97.14,179.35l-.36.06a133.42,133.42,0,0,0-20.12,5.1c-11.73,3.87-22.73,14.56-22.73,14.56-1.91-2.34-3.68-4.7-5.29-7.07h0c.42-.39,11.23-10.74,22.73-14.55a138.91,138.91,0,0,1,21.27-4.92,15.42,15.42,0,0,0,1.5,2.77C95.21,176.79,96.15,177.87,97.14,179.35Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tape-7",
    "data-name": "tape"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M60.14,205.52l.71,2.55c-2.43-2-4.84-5.27-6.63-7.77l-.39-1.19C56,200.93,57.75,203.82,60.14,205.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M93,173.23c-.1.05-.46.31-.57.37A111,111,0,0,0,76.83,184c-9.46,7.26-16.69,21.55-16.69,21.55-2.4-1.7-4.17-4.59-6.3-6.4,0,0,.28-.67.28-.68.27-.5,6.64-12.59,15.91-19.73,7.08-5.43,15.35-7.86,19.85-10.34.66.8,1.52,2.28,2.1,3.18A9.94,9.94,0,0,1,93,173.23Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tape-8",
    "data-name": "tape"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M92.19,172l-.62.14c-.75-2.55-2.73-5.1-3.36-7.81l1.31.43C90.05,167.2,91.53,169.6,92.19,172Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M91.57,172.11S77,173.79,66.12,178.58c-7.57,3.34-13.36,9.31-16.87,13l-.83.89a42.22,42.22,0,0,1-4.14-8.69l1.14-1c4.44-4,11.21-9.94,18.18-13,10.87-4.79,24.62-5.46,24.62-5.46C88.84,167,90.82,169.56,91.57,172.11Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tape-9",
    "data-name": "tape"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M67.14,211.07l.16,2.7a79.3,79.3,0,0,1-6-5.4l-.12-1.94C63,208,65,209.58,67.14,211.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M99.48,181.23l-.27.15a144.29,144.29,0,0,0-17.68,11.25c-8.34,6.41-14.39,18.45-14.39,18.45-2.11-1.5-4.12-3-6-4.64h0c.23-.44,6.21-12.14,14.39-18.44a171.21,171.21,0,0,1,19-12.05c.58.71,1,1.5,1.66,2.19A42.72,42.72,0,0,0,99.48,181.23Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoomerangTapedBoom);
export default __webpack_public_path__ + "static/media/boomerang_tapedBoom.fb9765084cb37ea3bd805398d6d67a92.svg";
export { ForwardRef as ReactComponent };